<template>
  <vuetify-chip
    v-bind="$attrs"
    v-on="$listeners"
    :class="`type--${type} size--${size} ${badge ? 'badged' : ''}`"
  >
    <slot></slot>
  </vuetify-chip>
</template>

<script>
import { VChip } from 'vuetify/lib/components'

export default {
  name: 'BaseTag',
  components: {
    'vuetify-chip': VChip,
  },
  props: {
    type: {
      type: String,
      default: 'default',
      validator: function (value) {
        return [
          'default',
          'error',
          'success',
          'alert',
          'neutral',
          'disabled',
          'trial',
        ].includes(value)
      },
    },
    size: {
      type: String,
      default: 'small',
      validator: function (value) {
        return ['small', 'xsmall'].includes(value)
      },
    },
    badge: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.v-application .v-chip {
  &.size {
    &--small {
      height: 20px;
      font-weight: 500;
      font-size: 12px;
      line-height: 150%;
    }
    &--xsmall {
      height: 16px;
      font-weight: 400;
      font-size: 12px;
      line-height: 150%;
      padding: 0 4px;
    }

    .v-icon {
      transform: translateY(0.5px) !important;
    }
  }

  &.type {
    &--default {
      background: varFigma(brand-90);
      color: varFigma(brand-20-darkest);
    }
    &--success {
      background: varFigma(feedback-success-light);
      color: varFigma(feedback-success-dark);
    }
    &--error {
      background: varFigma(feedback-danger-light);
      color: varFigma(feedback-danger-dark);
    }
    &--alert {
      background: varFigma(feedback-warning-light);
      color: varFigma(feedback-warning-dark);
    }
    &--neutral {
      background: varFigma(neutral-95-lightest);
      color: varFigma(neutral-40-light);
    }
    &--disabled {
      background: varFigma(neutral-95-lightest);
      color: varFigma(neutral-70);
    }
    &--trial {
      background: varFigma(trial-trial);
      color: var(--neutral-100-white-light);
    }
  }

  &::before {
    opacity: 0 !important;
  }

  &.badged {
    ::v-deep .v-chip__content {
      margin-left: 4px !important;
    }
    &::after {
      background: currentColor;
      width: 4px;
      content: '';
      height: 4px;
      display: block;
      position: absolute;
      border-radius: 100%;
      left: 8px;
    }
  }
}
</style>
